import React, { useCallback, useMemo, useState } from 'react';
import { createContext } from '@shared/utils/createContext';
import { GetDashboardChecklistDataQuery, useGetDashboardChecklistDataQuery } from '@graphql/generated';

type DashboardChecklistContext = {
  isChecklistExpanded: boolean;
  toggleChecklist: () => void;
  checklistDataLoading: boolean;
  checklistData?: GetDashboardChecklistDataQuery;
  checklistItemsCompleted: number;
  checklistItemsTotal: number;
};

type DashboardChecklistContextProps = {
  eventHandle: string;
};

const [Provider, useDashboardChecklistContext] = createContext<DashboardChecklistContext>({ name: 'DashboardChecklist' });

const DashboardChecklistProvider: React.FC<DashboardChecklistContextProps> = ({ eventHandle, children }) => {
  const { loading: checklistDataLoading, data: checklistData } = useGetDashboardChecklistDataQuery({
    batchMode: 'fast',
    variables: {
      eventHandle
    },
    skip: !eventHandle
  });

  const [isChecklistExpanded, setIsChecklistExpanded] = useState(false);

  const toggleChecklist = useCallback(() => {
    setIsChecklistExpanded(prev => !prev);
  }, []);

  const ctx = useMemo<DashboardChecklistContext>(
    () => ({
      isChecklistExpanded,
      toggleChecklist,
      checklistDataLoading,
      checklistData,
      // TODO: Replace with actual data -> https://withjoy.atlassian.net/browse/CORE-5093
      checklistItemsCompleted: 0,
      checklistItemsTotal: 6
    }),
    [checklistData, checklistDataLoading, isChecklistExpanded, toggleChecklist]
  );

  return <Provider value={ctx}>{children}</Provider>;
};

export { DashboardChecklistProvider, useDashboardChecklistContext };
